<template>
  <div class="booster-shop-wrapper d-flex flex-column">
    <div class="d-flex align-center">
      <v-icon color="primary" left> fa-solid fa-rocket</v-icon>

      <div class="text-h6 font-weight-black font-italic">
        Aumente suas chances
      </div>
    </div>

    <div class="text-left text-body-1 font-weight-bold mb-1">
      Concurso #{{ _currentRaffle?.code }},
      <span class="primary--text font-weight-black">
        R$ {{ currencyMask(_currentRaffle?.awards?.cash) }}
      </span>
      na conta
    </div>

    <div class="text-body-2 text-left mb-4">
      Mais números, mais chances, mais perto do
      <span class="font-weight-bold">prêmio</span>. Aumente suas chances de
      <span class="font-weight-bold">ganhar</span>!
    </div>

    <loader v-if="loading.content" />

    <v-row v-else class="pb-2" justify="center" no-gutters>
      <v-col
        v-for="(item, i) in boosters"
        :key="i"
        cols="4"
        sm="3"
        xl="2"
        class="relative px-1 px-sm-2 mb-2"
      >
        <v-img
          v-if="item.tier === 3 && item.effects.multiplier < availableTickets"
          :src="require('@/assets/main/fire-flame.gif')"
          class="hot-sale"
          max-width="1.5rem"
          height="2.5rem"
        />

        <v-card
          class="rounded-xl"
          color="neutral2"
          @click="selectBooster(item)"
        >
          <section>
            <v-img
              :src="item.image"
              class="rounded-t-xl"
              contain
              :aspect-ratio="4 / 4"
            >
              <div class="d-flex flex-column fill-height full-width">
                <v-spacer />

                <div class="flag-package text-center">
                  <div
                    class="booster-text russo-one"
                    :class="`${fetchTierColor(
                      item.tier
                    )}--text text--lighten-2`"
                  >
                    +{{ item.effects.multiplier }}
                  </div>
                </div>
              </div>
            </v-img>
          </section>

          <section class="px-1 py-2">
            <div
              v-if="$vuetify.breakpoint.smAndUp"
              class="text-caption text-center neutral8--text"
            >
              R$
              {{
                currencyMask(
                  formatAmount(item.value / item.effects.multiplier, 2, 2)
                )
              }}
              por número
            </div>

            <div
              class="text-body-1 text-sm-h6 font-weight-black primary--text text-center px-1"
            >
              R$ {{ currencyMask(item.value) }}
            </div>
          </section>
        </v-card>
      </v-col>
    </v-row>

    <BuyDialog ref="buyDialog" @success:booster="purchasedTokens($event)" />

    <TokenDialog ref="tokenDialog" @closed="close()" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getItems } from "@/services/items";
import { currencyMask, formatAmount } from "@/helpers";
import BuyDialog from "../buyDialog/BuyDialog.vue";
import TokenDialog from "../tokenDialog/TokenDialog";

export default {
  name: "BoosterShop",

  components: {
    BuyDialog,
    TokenDialog,
  },

  data() {
    return {
      loading: {
        content: true,
        shop: false,
      },
      boosters: [],
    };
  },

  props: {
    availableTickets: {
      type: Number,
      default: 999999,
    },

    embeded: {
      type: Boolean,
      default: false,
    },
  },

  beforeMount() {
    this.getItems();
  },

  computed: {
    ...mapGetters({
      _user: "user",
      _currentRaffle: "currentRaffle",
    }),
  },

  methods: {
    async getItems() {
      try {
        this.loading.content = true;

        const payload = {
          sortBy: "value",
          sortOrder: "asc",
          buyable: true,
          itemType: "booster",
        };

        const { data } = await getItems(payload);

        this.boosters = data;
      } catch (error) {
        this.$alert(error?.message, "error");
      } finally {
        this.loading.content = false;
      }
    },

    purchasedTokens(event) {
      this.$emit("purchased", event);

      if (this.embeded) return;

      if (event) this.$refs.tokenDialog.open(event);
    },

    selectBooster(item) {
      this.$refs.buyDialog.open(item);
    },

    fetchTierColor(value) {
      const options = {
        1: "grey",
        2: "blue",
        3: "amber",
        4: "yellow",
      };

      return options[value];
    },

    fetchTierClass(value) {
      const options = {
        1: "common",
        2: "rare",
        3: "mythic",
        4: "mythic",
      };

      return options[value];
    },

    close() {
      this.$emit("close");
    },

    currencyMask,

    formatAmount,
  },
};
</script>

<style src="./style.scss" lang="scss" scoped />
